import { render, staticRenderFns } from "./uploadImgs.vue?vue&type=template&id=f62f2ad8&scoped=true&"
import script from "./uploadImgs.vue?vue&type=script&lang=js&"
export * from "./uploadImgs.vue?vue&type=script&lang=js&"
import style0 from "./uploadImgs.vue?vue&type=style&index=0&id=f62f2ad8&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f62f2ad8",
  null
  
)

export default component.exports